import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import ElementUI from 'element-ui';
import ElementPlus from "element-plus";
import echarts from "echarts";
import http from '@/api/config.js'
import axios from "axios";
import 'element-plus/dist/index.css'
import locale from "element-plus/lib/locale/lang/zh-cn"
import VueCookies from 'vue-cookies'
import screenfull from 'screenfull'
 
// import VideoPlayer from 'vue-video-player/src';
// require('vue-video-player/src/custom-theme.css')
// import 'video.js/dist/video-js.css'


// import locale from element plus lib locale lang zh-cn
// import 'element-plus/lib/theme-chalk/index.css';
// import Axios from "axios";
// Vue.prototype.$axios = Axios;
// 引入echart
// Vue.prototype.$echarts = echarts;
// 全局配置

// 创建axios实例
const axiosInstance = axios.create({
  // baseURL: 'https://cloud2.szkekj.com/iceplatform',
  baseURL: '',
//   http://192.168.0.124:8989/iceplatform/
  timeout: 30000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

// 添加请求拦截器
axiosInstance.interceptors.request.use(config => {
console.log(config.url ,'时间戳1')

  // 在请求url上添加时间戳
  config.url += ((/\?/).test(config.url) ? '&' : '?') + '_=' + Date.now();
console.log(config ,'时间戳2')

  return config;
}, error => {
  return Promise.reject(error);
});
export default axiosInstance;

import moment from "moment";
createApp(App).config.globalProperties.$moment = moment;
createApp(App).use(store).use(router).use(ElementPlus, { locale }).use(echarts).use(screenfull).use(VueCookies).mount("#app");
// createApp(App).use(store).use(router).use(ElementPlus, { locale }).use(echarts).use(screenfull).use(VideoPlayer).use(VueCookies).mount("#app");
createApp(App).config.globalProperties.$http = 'http'
createApp(App).config.globalProperties.$http = axios;
// app.config.globalProperties.$echarts = echarts